import { useMemo } from "react"
import { Box, useTheme } from "@mui/material"

import { Head } from "components/Head"
import { EmptyData } from "components/EmptyData"
import { MotionDiv, showContent } from "components/motions"

import { getIcon } from "utils/icon"

import { useTranslation } from "providers/i18n"

import {
  Header,
  HeaderMenuButton,
  HeaderSearchButton,
} from "extensions/one-siam/components/Header"
import { PageLayout } from "extensions/one-siam/layouts/PageLayout"
import { AppNavigation } from "extensions/one-siam/container/AppNavigation"
import { SeeAndDoIcon } from "extensions/one-siam/components/icons"
import { SeeAndDoCard } from "extensions/one-siam/components/domains/see-and-do"
import { useSeeAndDo } from "extensions/one-siam/hooks"

export const SeeAndDoPage = ({ Layout = PageLayout }) => {
  const { t } = useTranslation({ defaultValue: null })
  const theme = useTheme()
  const {
    root,
    gridItem,
    gridContainer,
    emptyDataContainer,
    headerWrapper,
    navigationWrapper,
  } = theme.components?.[`SeeAndDoPage`]?.styleOverrides || {}

  const { hasData, sortedPostByDefaultVenue } = useSeeAndDo()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.seeAndDo) || <SeeAndDoIcon />,
    [theme]
  )
  return (
    <>
      <Head title={t("See & Do")} />
      <Layout
        header={
          <Box sx={headerWrapper}>
            <Header
              title={t("See & Do")}
              menu={<HeaderMenuButton />}
              search={<HeaderSearchButton />}
            />
          </Box>
        }
      >
        <MotionDiv
          variants={showContent}
          initial="initial"
          animate="animate"
          sx={root}
        >
          {hasData ? (
            <Box sx={gridContainer}>
              {sortedPostByDefaultVenue.map((post, index) => (
                <SeeAndDoCard
                  sx={gridItem}
                  data={post}
                  key={`see-and-do-${index}`}
                />
              ))}
            </Box>
          ) : (
            <Box sx={emptyDataContainer}>
              <EmptyData
                icon={emptyIcon}
                primary={t("Coming soon")}
                secondary={t("Stay tuned for the update")}
              />
            </Box>
          )}
        </MotionDiv>
        <Box sx={navigationWrapper}>
          <AppNavigation />
        </Box>
      </Layout>
    </>
  )
}
